"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var contract_wrappers_1 = require("@0x/contract-wrappers");
var order_utils_1 = require("@0x/order-utils");
var remaining_fillable_calculator_1 = require("@0x/order-utils/lib/src/remaining_fillable_calculator");
var utils_1 = require("@0x/utils");
var _ = require("lodash");
var constants_1 = require("../constants");
var types_1 = require("../types");
exports.orderProviderResponseProcessor = {
    throwIfInvalidResponse: function (response, request) {
        var makerAssetData = request.makerAssetData, takerAssetData = request.takerAssetData;
        _.forEach(response.orders, function (order) {
            if (order.makerAssetData !== makerAssetData || order.takerAssetData !== takerAssetData) {
                throw new Error(types_1.AssetBuyerError.InvalidOrderProviderResponse);
            }
        });
    },
    /**
     * Take the responses for the target orders to buy and fee orders and process them.
     * Processing includes:
     * - Drop orders that are expired or not open orders (null taker address)
     * - If shouldValidateOnChain, attempt to grab fillable amounts from on-chain otherwise assume completely fillable
     * - Sort by rate
     */
    processAsync: function (orderProviderResponse, isMakerAssetZrxToken, expiryBufferSeconds, orderValidator) {
        return __awaiter(this, void 0, void 0, function () {
            var filteredOrders, unsortedOrders, takerAddresses, _a, ordersInfo, tradersInfo_1, ordersAndTradersInfo, err_1, sortedOrders, result;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        filteredOrders = filterOutExpiredAndNonOpenOrders(orderProviderResponse.orders, expiryBufferSeconds);
                        unsortedOrders = filteredOrders;
                        if (!(orderValidator !== undefined)) return [3 /*break*/, 4];
                        takerAddresses = _.map(filteredOrders, function () { return constants_1.constants.NULL_ADDRESS; });
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, orderValidator
                                .getOrdersAndTradersInfo(filteredOrders, takerAddresses)
                                .callAsync()];
                    case 2:
                        _a = __read.apply(void 0, [_b.sent(), 2]), ordersInfo = _a[0], tradersInfo_1 = _a[1];
                        ordersAndTradersInfo = ordersInfo.map(function (orderInfo, index) {
                            return {
                                orderInfo: orderInfo,
                                traderInfo: tradersInfo_1[index],
                            };
                        });
                        // take orders + on chain information and find the valid orders and remaining fillable maker asset amounts
                        unsortedOrders = getValidOrdersWithRemainingFillableMakerAssetAmountsFromOnChain(filteredOrders, ordersAndTradersInfo, isMakerAssetZrxToken);
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _b.sent();
                        return [3 /*break*/, 4];
                    case 4:
                        sortedOrders = isMakerAssetZrxToken
                            ? order_utils_1.sortingUtils.sortFeeOrdersByFeeAdjustedRate(unsortedOrders)
                            : order_utils_1.sortingUtils.sortOrdersByFeeAdjustedRate(unsortedOrders);
                        result = unbundleOrdersWithAmounts(sortedOrders);
                        return [2 /*return*/, result];
                }
            });
        });
    },
};
/**
 * Given an array of orders, return a new array with expired and non open orders filtered out.
 */
function filterOutExpiredAndNonOpenOrders(orders, expiryBufferSeconds) {
    var result = _.filter(orders, function (order) {
        return (order_utils_1.orderCalculationUtils.isOpenOrder(order) &&
            !order_utils_1.orderCalculationUtils.willOrderExpire(order, expiryBufferSeconds));
    });
    return result;
}
/**
 * Given an array of orders and corresponding on-chain infos, return a subset of the orders
 * that are still fillable orders with their corresponding remainingFillableMakerAssetAmounts.
 */
function getValidOrdersWithRemainingFillableMakerAssetAmountsFromOnChain(inputOrders, ordersAndTradersInfo, isMakerAssetZrxToken) {
    // iterate through the input orders and find the ones that are still fillable
    // for the orders that are still fillable, calculate the remaining fillable maker asset amount
    var result = _.reduce(inputOrders, function (accOrders, order, index) {
        // get corresponding on-chain state for the order
        var _a = ordersAndTradersInfo[index], orderInfo = _a.orderInfo, traderInfo = _a.traderInfo;
        // if the order IS NOT fillable, do not add anything to the accumulations and continue iterating
        if (orderInfo.orderStatus !== contract_wrappers_1.OrderStatus.Fillable) {
            return accOrders;
        }
        // if the order IS fillable, add the order and calculate the remaining fillable amount
        var transferrableAssetAmount = utils_1.BigNumber.min(traderInfo.makerAllowance, traderInfo.makerBalance);
        var transferrableFeeAssetAmount = utils_1.BigNumber.min(traderInfo.makerZrxAllowance, traderInfo.makerZrxBalance);
        var remainingTakerAssetAmount = order.takerAssetAmount.minus(orderInfo.orderTakerAssetFilledAmount);
        var remainingMakerAssetAmount = order_utils_1.orderCalculationUtils.getMakerFillAmount(order, remainingTakerAssetAmount);
        var remainingFillableCalculator = new remaining_fillable_calculator_1.RemainingFillableCalculator(order.makerFee, order.makerAssetAmount, isMakerAssetZrxToken, transferrableAssetAmount, transferrableFeeAssetAmount, remainingMakerAssetAmount);
        var remainingFillableAmount = remainingFillableCalculator.computeRemainingFillable();
        // if the order does not have any remaining fillable makerAsset, do not add anything to the accumulations and continue iterating
        if (remainingFillableAmount.lte(constants_1.constants.ZERO_AMOUNT)) {
            return accOrders;
        }
        var orderWithRemainingFillableMakerAssetAmount = __assign({}, order, { remainingFillableMakerAssetAmount: remainingFillableAmount });
        var newAccOrders = _.concat(accOrders, orderWithRemainingFillableMakerAssetAmount);
        return newAccOrders;
    }, []);
    return result;
}
/**
 * Given an array of orders with remaining fillable maker asset amounts. Unbundle into an instance of OrdersAndRemainingFillableMakerAssetAmounts.
 * If an order is missing a corresponding remainingFillableMakerAssetAmount, assume it is completely fillable.
 */
function unbundleOrdersWithAmounts(ordersWithAmounts) {
    var result = _.reduce(ordersWithAmounts, function (acc, orderWithAmount) {
        var orders = acc.orders, remainingFillableMakerAssetAmounts = acc.remainingFillableMakerAssetAmounts;
        var remainingFillableMakerAssetAmount = orderWithAmount.remainingFillableMakerAssetAmount, order = __rest(orderWithAmount, ["remainingFillableMakerAssetAmount"]);
        // if we are still missing a remainingFillableMakerAssetAmount, assume the order is completely fillable
        var newRemainingAmount = remainingFillableMakerAssetAmount || order.makerAssetAmount;
        // if remaining amount is less than or equal to zero, do not add it
        if (newRemainingAmount.lte(constants_1.constants.ZERO_AMOUNT)) {
            return acc;
        }
        var newAcc = {
            orders: _.concat(orders, order),
            remainingFillableMakerAssetAmounts: _.concat(remainingFillableMakerAssetAmounts, newRemainingAmount),
        };
        return newAcc;
    }, {
        orders: [],
        remainingFillableMakerAssetAmounts: [],
    });
    return result;
}
//# sourceMappingURL=order_provider_response_processor.js.map